module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAf0lEQVQ4y2NgGBTgnKDaf3Iw7Q24Zqj8/5qxMvkGPMmTA2OSDLisofL/urkyGH/ZKAnGMD5IjqABlxRV/7+fLf3/z0UxFAwSA8kR7YU3/QhDQGySw+DTCsn/33ZIgDGITZIBIL+CbL0gpQrGIDa6//EacEFC9T8xYtRLSEMbAABrHUYEoKvw+QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/VN.png
// module id = 1300
// module chunks = 0